
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/vision",
      function () {
        return require("private-next-pages/vision/index.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/vision"])
      });
    }
  